import { createContext } from "react";

const CalculatorContext = createContext();
export default CalculatorContext;
